import { render, staticRenderFns } from "./Digitalsecurity.vue?vue&type=template&id=2a86e79d&"
import script from "./Digitalsecurity.vue?vue&type=script&lang=js&"
export * from "./Digitalsecurity.vue?vue&type=script&lang=js&"
import style0 from "./Digitalsecurity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports